import ProductActionType from '../actionTypes/ProductActionType';

const initialState = { listProduct: [], allProducts: {} };

export default (state = initialState, action) => {
  switch (action.type) {
    case ProductActionType.CREATE_PRODUCT:
      return { ...state, createdProduct: action.createdProduct };
    case ProductActionType.DELETE_PRODUCT:
      return { ...state, deleteProduct: action.deleteProduct };
    case ProductActionType.UPDATE_PRODUCT:
      return { ...state, editedProduct: action.editedProduct };
    case ProductActionType.ADD_ORDER_PRODUCT:
      return { ...state, productOrderAdd: action.productOrderAdd };
    case ProductActionType.UPDATE_ORDER_PRODUCT:
      return { ...state, productOrderUpdated: action.productOrderUpdated };
    case ProductActionType.DELETE_ORDER_PRODUCT:
      return { ...state, productOrderDeleted: action.productOrderDeleted };
    case ProductActionType.UPDATE_LIST:
      return { ...state, listProduct: action.listProduct };
    case ProductActionType.UPDATE_ALL_PRODUCT:
      return { ...state, allProducts: action.allProducts };
    default:
      return state;
  }
};
